<template>
    <div :class="`observed-item-value`">
        <div v-if="qualityValue" class="observed-item-value" :style="`background-color: ${qualityValue.background}`">
            <v-chip 
                class="mr-2"
                :color="qualityValue.background"
                :style="`border: 1px solid ${qualityValue.borderColor}`"
                label
            >
                <span :style="`color: ${qualityValue.textColor}`">{{qualityValue.title}}</span>
            </v-chip>
            <span :key="`span-${hourKey}-${index}`">
                {{ showNormalValue(item[`hour${hourKey}Value`]) }}
            </span>
        </div>
        <span v-else :key="`span-${hourKey}-${index}`">
            {{ showNormalValue(item[`hour${hourKey}Value`]) }}
        </span>
    </div>
  
</template>

<script>
/* import moment from "moment-timezone"; */
export default {
    name: "ObservedSensorValueTable",
    props: ["item", "hourKey", "index", "qualitiesTags"],
    data: () => ({
        tag: undefined,
        sensorDescription: undefined,
        tagValue: undefined,
    }),

    /* created(){
        this.initialize();
    },

    watch:{
        item(value){
            if(value){
                this.initialize();
            }
        },
    }, */

    computed:{
        qualityValue(){
            return this.qualitiesTags.find((quality) => quality.qualitiyId == this.item[`hour${this.hourKey}qualityId`])
        },
    },

    methods:{

        showNormalValue(value){
            return value ? value : value === 0 ? Number(value).toFixed(1) :  "--";
        }
    }
}
</script>

<style scoped>

    .observed-item-value{
        width: 100%; 
        height:100%;
        margin: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>